export function fmtG(g: number): string {
  if (g >= 1000) return (g / 1000).toFixed(g % 1000 === 0 ? 0 : 2) + " kg";
  return (Math.round(g * 10) / 10).toLocaleString() + " g";
}

export function fmtTemp(t: number): string {
  return t.toFixed(t % 1 ? 1 : 0);
}

export function fmtYeast(pct: number): string {
  const dec = pct < 1 ? 3 : pct < 10 ? 2 : 1;
  return pct.toFixed(dec).replace(/\.?0+$/, "");
}

export function climate(t: number): string {
  if (t <= 6) return "fridge";
  if (t < 18) return "cool room";
  if (t <= 22) return "room temp";
  if (t <= 25) return "warm";
  if (t <= 27) return "summer";
  return "proofer";
}
